import script from "./Records.vue?vue&type=script&setup=true&lang=js"
export * from "./Records.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Records.vue?vue&type=style&index=1&id=2be151d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be151d6"]])

export default __exports__